import { useTranslation } from 'react-i18next'
import Image from 'next/image'

import { ASSET_PATHS } from '@/services/paths'

import * as S from './styles'

interface LoadingProps {
  className?: string
}

export default function Loading({ className }: LoadingProps) {
  const { t } = useTranslation()

  return (
    <S.LoadingCSS id="Loading" className={className && className}>
      <Image
        src={ASSET_PATHS.animation_load}
        alt={t('alts.load')}
        width={50}
        height={50}
      />
    </S.LoadingCSS>
  )
}
